// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../../../../../../node_modules/sass-loader/lib/loader.js!./statistics-page.scss?vue&type=style&index=0&id=95245dc6&lang=scss&scoped=true&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("5d22ae8a", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../../../../../../node_modules/sass-loader/lib/loader.js!./statistics-page.scss?vue&type=style&index=0&id=95245dc6&lang=scss&scoped=true&", function() {
     var newContent = require("!!../../../../../../../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../../../../../../node_modules/sass-loader/lib/loader.js!./statistics-page.scss?vue&type=style&index=0&id=95245dc6&lang=scss&scoped=true&");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}